/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiSettingScopeFromJSON, StreemApiSettingScopeToJSON, } from './';
export function StreemApiSettingFromJSON(json) {
    return StreemApiSettingFromJSONTyped(json, false);
}
export function StreemApiSettingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'filterToScope': !exists(json, 'filter_to_scope') ? undefined : StreemApiSettingScopeFromJSON(json['filter_to_scope']),
    };
}
export function StreemApiSettingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'value': value.value,
        'type': value.type,
        'filter_to_scope': StreemApiSettingScopeToJSON(value.filterToScope),
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiSettingType;
(function (StreemApiSettingType) {
    StreemApiSettingType["BOOLEAN"] = "TYPE_BOOLEAN";
    StreemApiSettingType["DOUBLE"] = "TYPE_DOUBLE";
    StreemApiSettingType["INTEGER"] = "TYPE_INTEGER";
    StreemApiSettingType["INVALID"] = "TYPE_INVALID";
    StreemApiSettingType["STRING"] = "TYPE_STRING";
})(StreemApiSettingType || (StreemApiSettingType = {}));
//# sourceMappingURL=StreemApiSetting.js.map